export default "__VITE_PUBLIC_ASSET__fd9d34e3__"